import React, { Component } from 'react';
import invoke from 'react-native-webview-invoke/browser'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Custom-css.css';
import '../../../custom-input-file.css';
import Spinner from './../../Spinner'
import {Container, Button} from 'react-bootstrap'
import history from './../../history';
import {ucWords, formatMoney, formatDateDFYHI, formatAngka} from './../../custom-func'
import { IoPrint, IoLogoWhatsapp, IoArrowBack} from "react-icons/io5";
import Swal from 'sweetalert2'
import {
    addTransactionPhotoQuery,
    buildTransactionPhotoUrls,
    getTransactionPhotoUrl
} from './../../transaction-photo-url'

const swalBirubi = Swal.mixin({
    customClass: {
        header: 'p-0 m-0',
        confirmButton: 'btn btn-birubi-outline btn-sm color-birubi',
        cancelButton: 'btn btn-outline-dark btn-sm ml-2'
    },
    buttonsStyling: false
})


const {
    REACT_APP_API_URL,
} = process.env;

const PRINT_WEB_LOG_TAG = '[BirubiPrintWeb]';

const getErrorLog = (error) => {
    if(error instanceof Error){
        return {
            message: error.message,
            stack: error.stack
        }
    }

    return {
        message: String(error)
    }
}

const printWebLog = (step, data) => {
    if(data === undefined){
        console.log(PRINT_WEB_LOG_TAG, step)
        return
    }

    console.log(PRINT_WEB_LOG_TAG, step, data)
}

const printWebError = (step, error, context = {}) => {
    console.log(PRINT_WEB_LOG_TAG, step, {
        ...context,
        error: getErrorLog(error)
    })
}

const parseJsonArray = (value) => {
    if(!value){
        return []
    }

    if(Array.isArray(value)){
        return value
    }

    try{
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
    }catch(error){
        printWebError('json:parse-array:error', error, {value})
        return []
    }
}

class CetakNota extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: true,
            disabled: false,
            loadingDetail: true,
            photoVersion: Date.now(),
            selesai:'',
            delete: 0,
            print_color: 'text-danger',
            transaksi: null,
            payment: [],
            detail_transaksi: [],
            photoModalOpen: false,
            photoModalUrl: ''
        };
        this.query = new URLSearchParams(this.props.location.search);

        this.getDetailItem = this.getDetailItem.bind(this);
        this.goToPrint = invoke.bind('goToPrint');
        this.konekBluetooth = invoke.bind('konekBluetooth');
        this.handlePrintConnection = this.handlePrintConnection.bind(this);
        this.handlePrintStatus = this.handlePrintStatus.bind(this);
        this.printNota = this.printNota.bind(this);
        this.notaWA = this.notaWA.bind(this);
        this.konekB = this.konekB.bind(this);
        this.handlePhotoError = this.handlePhotoError.bind(this);
        this.openPhotoModal = this.openPhotoModal.bind(this);
        this.closePhotoModal = this.closePhotoModal.bind(this);
    }

    componentDidMount(){
        invoke.define('changePrint', this.handlePrintConnection)
        invoke.define('statusPrint', this.handlePrintStatus)
        printWebLog('bridge:callbacks-defined')

        if(localStorage.getItem('token') === null){
            history.replace('/')
        }else{
            const role = JSON.parse(localStorage.getItem('role'));
            if(role.ksr !== 1){
                swalBirubi.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Maaf anda tidak memiliki akses di fitur ini',
                    showCancelButton: false,
                    confirmButtonText: 'Kembali'
                  }).then((result) => {
                    history.goBack()
                  })
            }

            this.getDetailItem()
        }
    }

    handlePrintConnection(hasil) {
        printWebLog('callback:changePrint', {hasil})
        this.setState({
            print_color: hasil === 1 ? 'text-success' : 'text-danger'
        })
        return true
    }

    handlePrintStatus(status) {
        printWebLog('callback:statusPrint', {status})
        swalBirubi.close()
        if(status === 'sukses' || status === 'berhasil'){
            swalBirubi.fire(
                'Nota berhasil diproses!',
                'Silahkan lanjutkan proses nota.'
            )
        }else if(status === 'printer_tidak_terhubung'){
            swalBirubi.fire(
                'Printer belum terhubung!',
                'Silahkan pilih printer terlebih dahulu, lalu coba cetak lagi.'
            )
        }else{
            swalBirubi.fire(
                'Cetak nota gagal!',
                'Silahkan coba print lagi.'
            )
        }
        return true
    }

    getPrintRequest(endpoint){
        const kdTx = this.query.get('kdTx')
        const schema = localStorage.getItem('schema')
        const params = new URLSearchParams({
            kdTx: kdTx || '',
            schema: schema || ''
        })

        const request = {
            urlGetNota: REACT_APP_API_URL+endpoint+'?'+params.toString(),
            kdTx: kdTx,
            schema: schema
        }

        printWebLog('request:build', {endpoint, request})
        return request
    }

    async printNota(endpoint){
        swalBirubi.fire(
            'Cetak Nota!',
            'Silahkan periksa printer anda. Printer mungkin membutuhkan waktu beberapa saat. Pastikan HP anda terkoneksi dengan internet!'
        )
        const request = this.getPrintRequest(endpoint)
        printWebLog('command:goToPrint:send', {endpoint, request})

        try{
            await this.goToPrint(request)
            printWebLog('command:goToPrint:accepted', {endpoint})
        }catch(error){
            printWebError('command:goToPrint:error', error, {endpoint, request})
            this.handlePrintStatus('gagal')
        }
    }

    async notaWA(){
        const endpoint = 'get-nota-wa'
        const request = this.getPrintRequest(endpoint)
        printWebLog('command:goToPrint:send', {endpoint, request})

        try{
            await this.goToPrint(request)
            printWebLog('command:goToPrint:accepted', {endpoint})
        }catch(error){
            printWebError('command:goToPrint:error', error, {endpoint, request})
            this.handlePrintStatus('gagal')
        }
    }

    async konekB(){
        await this.konekBluetooth()
    }

    handlePhotoError(event, fileName) {
        const image = event.currentTarget
        const schema = localStorage.getItem('schema')
        const baseUrls = buildTransactionPhotoUrls(schema, fileName)
        const candidates = baseUrls
            .map((url) => addTransactionPhotoQuery(url, Date.now(), 'w_100,h_80'))
            .concat(baseUrls.map((url) => addTransactionPhotoQuery(url, Date.now(), '')))
        const currentStep = parseInt(image.dataset.photoStep || '0', 10)
        const nextStep = currentStep + 1

        if(nextStep < candidates.length){
            image.dataset.photoStep = String(nextStep)
            image.src = candidates[nextStep]
            printWebLog('photo:error:fallback-candidate', {
                fileName,
                src: image.src,
                step: nextStep
            })
            return
        }

        const missing = image.parentNode ? image.parentNode.querySelector('[data-photo-missing="1"]') : null
        if(missing){
            missing.style.display = 'flex'
        }

        image.style.display = 'none'
        printWebLog('photo:error:hidden', {
            fileName,
            src: image.src
        })
    }

    openPhotoModal(fileName, event) {
        const schema = localStorage.getItem('schema')
        const baseUrls = buildTransactionPhotoUrls(schema, fileName)
        const image = event.currentTarget.querySelector('img')

        if(baseUrls.length === 0 || (image && image.style.display === 'none')){
            printWebLog('photo:error:hidden', {
                fileName
            })
            return
        }

        const currentStep = image ? parseInt(image.dataset.photoStep || '0', 10) : 0
        const currentIndex = baseUrls.length > 0 ? currentStep % baseUrls.length : 0

        this.setState({
            photoModalOpen: true,
            photoModalUrl: addTransactionPhotoQuery(baseUrls[currentIndex] || baseUrls[0], Date.now(), '')
        })
    }

    closePhotoModal() {
        this.setState({
            photoModalOpen: false,
            photoModalUrl: ''
        })
    }

    getDetailItem(){
        this.setState({loadingDetail: true})

        fetch(REACT_APP_API_URL+'get-transaksi', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                kode_user: localStorage.getItem('kode_user'),
                schema: localStorage.getItem('schema'),
                kdTx: this.query.get('kdTx'),
                api_token: localStorage.getItem('token')
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            printWebLog('detail:response', {
                status: responseJson.status,
                hasHeader: Boolean(responseJson.data && responseJson.data.header),
                detailCount: responseJson.data && Array.isArray(responseJson.data.detail) ? responseJson.data.detail.length : 0,
                paymentCount: responseJson.data && Array.isArray(responseJson.data.payment) ? responseJson.data.payment.length : 0
            })

            const data = responseJson.data || {}
            this.setState({
                detail_transaksi: Array.isArray(data.detail) ? data.detail : [],
                transaksi: data.header || null,
                payment: Array.isArray(data.payment) ? data.payment : [],
                selesai: data.selesai || '',
                delete: data.delete || 0,
                loadingDetail: false,
                disabled: false,
                photoVersion: Date.now(),
            })
        })
        .catch((error) => {
            printWebError('detail:error', error, {kdTx: this.query.get('kdTx')})
            this.setState({disabled:false, loadingDetail:false})
        });
    }

    hapusNota(){
        let ts = this
        swalBirubi.fire({
            title: 'Alasan Pembatalan ?',
            icon: 'warning',
            input: 'text',
            showCancelButton: true,
            confirmButtonText: 'Ya, Hapus!',
            preConfirm: (text) => {
                return fetch(REACT_APP_API_URL+'hapus-transaksi', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        kode_user: localStorage.getItem('kode_user'),
                        schema: localStorage.getItem('schema'),
                        kdTx: ts.query.get('kdTx'),
                        alasan_batal: text,
                        api_token: localStorage.getItem('token')
                    })
                })
                .then((response) => response.json())
                .then((responseJson) => {
                    if(responseJson.status === true){
                        swalBirubi.fire({
                            icon: 'success',
                            title: 'Berhasil!',
                            text: responseJson.message,
                            timer: 3000,
                            timerProgressBar: true
                        }).then((result) => {
                            history.replace('/')
                        })
                    }else{
                        swalBirubi.fire(
                            'Gagal!',
                            responseJson.message
                        )
                    }
                })
                .catch(error => {
                    Swal.showValidationMessage(
                    `Request failed: ${error}`
                    )
                })
            },

          })
    }


    render() {  
        const transaksi = this.state.transaksi || {}
        const isDetailLoaded = this.state.loadingDetail === false && this.state.transaksi !== null
        const isCanceled = isDetailLoaded && transaksi.dibatalkan_oleh !== null && transaksi.dibatalkan_oleh !== undefined
        const schema = localStorage.getItem('schema')

        const detPayment = this.state.payment.map((val, id) => {
            return (
                <div key={val.kode_pembayaran} className="mb-3">
                    <div className="row">
                        <div className="col-6 text-grey">
                            <div>{formatDateDFYHI(val.tanggal_pembayaran)}</div>
                            <div>{val.bank}</div>
                        </div>
                        <div className="col-6 text-right text-grey">
                            <div>{val.nomor_pembayaran}</div>
                            <div>Rp {formatMoney(val.total_pembayaran)}</div>
                        </div>
                    </div>
                </div>
            )
        });

        const detailItemTx = this.state.detail_transaksi.map((val, id) => {
            return (
                <div key={val.kode_detail_tx} className="border mb-3">

                    <div className="w-100 border-bottom">
                        <div className="p-1 pl-2">
                            <div className="font-weight-bold" >{ucWords(val.nama_item)}</div>

                            {
                                val.total_luas > 0 ?
                                    <div className="text-grey">{formatAngka(val.panjang_item) * 1} x {formatAngka(val.lebar_item) * 1} {val.nama_satuan} = {formatAngka(val.total_luas) * 1} {val.nama_satuan}</div>
                                    : null
                            }
                                    
                            <div className="row"> 
                                <div className="col-8">
                                    {
                                        val.total_luas > 0 ?
                                            <div className="text-grey">{formatAngka(val.total_luas) * 1} {val.nama_satuan} x {formatAngka(val.total_item) * 1} x Rp {formatMoney(val.harga_layanan)}</div>
                                            :
                                            <div className="text-grey">{formatAngka(val.total_item)} {val.nama_satuan} x Rp {formatMoney(val.harga_layanan)}</div>
                                    }
                                </div>

                                <div className="col-4 text-grey text-right">
                                    Rp {formatMoney(val.total_harga)}
                                </div>
                            </div>
                            
                            <div className="font-10 text-grey mt-2">Catatan : {val.notes ? val.notes : '-'}</div>
                            <div className="font-10 text-grey">Status : {val.stat_desc}</div>

                            {
                                parseJsonArray(val.jenis_pakaian).length > 0 ?
                                    parseJsonArray(val.jenis_pakaian).map((v, i) => {
                                        return(
                                        <span key={v.kode_pakaian} className="font-10 text-grey">
                                            {' '} {ucWords(v.nama_pakaian)} : {v.jumlah_pakaian} PCS | 
                                        </span>
                                    )})
                                : null
                            }

                        </div>
                    </div>

                    <div className="border-bottom w-100">
                        <div style={{overflowX:'auto', display:'flex'}}>
                        {   
                            parseJsonArray(val.gambar).map((v, i) => {
                                const photoSrc = getTransactionPhotoUrl(schema, v, this.state.photoVersion)

                                return(
                                    <div style={{flex: '0 0 25%', height:90}}  key={i} className="p-1" >
                                        {
                                            photoSrc ?
                                            <button
                                                type="button"
                                                style={photoStyles.thumbnailButton}
                                                onClick={(event) => this.openPhotoModal(v, event)}
                                            >
                                                <img
                                                    alt="Foto transaksi"
                                                    data-photo-step="0"
                                                    style={photoStyles.thumbnailImage}
                                                    src={photoSrc}
                                                    onError={(event) => this.handlePhotoError(event, v)}
                                                />
                                                <span data-photo-missing="1" style={photoStyles.missingText}>Foto tidak ditemukan</span>
                                            </button>
                                            :
                                            <div style={photoStyles.missingBox}>Foto tidak ditemukan</div>
                                        }
                                    </div>
                                )
                            })
                        }
                        </div>
                    </div>

                </div>
            );
        });


        return (
            this.state.disabled === true || this.state.loadingDetail === true ?
            <Spinner /> 
            :
            <div>
                <div className="fixed-position bg-white">
                    <div className="header border-bottom shadow-sm">
                        <div className="row">
                            {
                                this.query.get('back') === '1' ?
                                <div className="col-1" onClick={() => history.goBack()}>
                                    <h5><IoArrowBack /></h5>
                                </div>
                                :
                                <div className="col-1" onClick={() => history.replace('/')}>
                                    <h5><IoArrowBack /></h5>
                                </div>
                            }
                            <div className="col-9">
                                <h5 className="mt-1">{transaksi.nomor_nota || ''}</h5>
                            </div>
                            <div className="col-1" onClick={() => this.konekB() }>
                                <h4 className="m-0 p-0"><IoPrint className={this.state.print_color} /></h4>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="pt-reg pb-detailTx">
                    <Container>
                        <div className="row">
                            <div className="col-6">
                                <div className="font-weight-bold">{transaksi.nama_pelanggan || ''}</div>
                            </div>
                            <div className="col-6 text-right">
                                <div>{transaksi.tlp_pelanggan || ''}</div>
                            </div>
                        </div>


                        <div className="detail-transaksi">
                            <div className="row">
                                <div className="col-4">
                                    <div className="white font-10">Sisa Tagihan</div>  
                                    {
                                        transaksi.sisa_pembayaran > 0 ?
                                            <div className="font-weight-bold white">Rp {formatMoney(transaksi.sisa_pembayaran)}</div>
                                        :
                                            <div className="font-weight-bold white">Lunas</div>    
                                    }  
                                </div>
                                {
                                    isCanceled === false ?
                                        <div className="col-8 mt-1">
                                            {
                                                this.query.get('ambil') === '1' ?
                                                    transaksi.tanggal_ambil === null ?
                                                        <Button className="btn-light btn-birubi-outline text-white btn-sm float-right ml-1" onClick={ () => history.push('/pengambilan-transaksi?kdTx='+this.query.get('kdTx')) } ><span className="color-birubi">Ambil </span></Button>
                                                    : null
                                                : null
                                            }

                                            {
                                                transaksi.sisa_pembayaran > 0 ?
                                                        <Button className="btn-light btn-birubi-outline text-white btn-sm float-right ml-1" onClick={ () => history.push('/pembayaran?kdTx='+this.query.get('kdTx')) } ><span className="color-birubi">Bayar </span></Button>
                                                : null
                                            }
                                        </div>
                                    : null
                                }
                            </div>
                        </div>

                        {
                            isCanceled ?
                                <div className="alert alert-danger" role="alert">
                                    Dibatalkan: {formatDateDFYHI(transaksi.tanggal_batal)} <br/>
                                    Alasan : {transaksi.alasan_batal || '-'}
                                </div>
                            : 
                            <div className="text-center mb-3">
                                Estimasi Selesai
                                <h5>{this.state.selesai}</h5>    
                            </div>   
                        }

                        {detailItemTx}

                        {
                            this.state.payment.length > 0 ?
                            <div>
                                <div className="text-center mb-3 pt-3">
                                    History pembayaran
                                </div>   
                                {detPayment}
                            </div>
                        : null
                        }

                        {
                            isCanceled === false ?
                                this.state.payment.length === 0 ?
                                    this.state.delete === 1 ?
                                        <Button variant="outline-danger" block onClick={ () => this.hapusNota() }>Hapus Transaksi</Button>
                                    : null
                                : null
                            : null
                        }

                        <div className="row pt-3 mt-3 border-top">
                            <div className="col-9 text-grey text-right">
                                Total Gross &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-grey">
                                {formatMoney(transaksi.total_gross)}
                            </div>

                            <div className="col-9 text-grey text-right">
                                Total Disc &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-grey">
                                {formatMoney(transaksi.disc_amount)}
                            </div>

                            <div className="col-9 text-grey text-right">
                                Pembulatan &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-grey">
                                {formatMoney(transaksi.pembulatan)}
                            </div>

                            <div className="col-9 text-grey text-right">
                                Total Nett &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-grey">
                                {formatMoney(transaksi.total_nett)}
                            </div>

                            <div className="col-9 text-success font-weight-bold text-right">
                                Total Bayar &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-success font-weight-bold">
                                {formatMoney(transaksi.total_pembayaran)}
                            </div>

                            <div className="col-9 text-danger font-weight-bold text-right">
                                Sisa Pembayaran &nbsp;&nbsp; Rp
                            </div>
                            <div className="col-3 text-right text-danger font-weight-bold">
                                {formatMoney(transaksi.sisa_pembayaran)}
                            </div>
                        </div>

                    </Container>
                </div>

                {
                    isCanceled === false ?
                        <div className="fix-bottom">
                            <Container>
                                <div className="row">
                                    <div className="col-4  p-1">
                                        <Button className="btn-light w-100 btn-birubi-outline text-white font-10" disabled={this.state.disabled ? 'disabled' : ''} block onClick={ () => this.notaWA() } ><span className="color-birubi"><h4 className="m-0 p-0"><IoLogoWhatsapp /></h4> Whatsapp </span></Button>
                                    </div>
                                    <div className="col-4  p-1">
                                        <Button className="btn-light w-100 btn-birubi-outline text-white font-10" disabled={this.state.disabled ? 'disabled' : ''} block onClick={ () => this.printNota('get-nota-cust') } ><span className="color-birubi"><h4 className="m-0 p-0"><IoPrint /></h4>  Pelanggan </span></Button>
                                    </div>
                                    <div className="col-4  p-1">
                                        <Button className="btn-light w-100 btn-birubi-outline text-white font-10" disabled={this.state.disabled ? 'disabled' : ''} block onClick={ () => this.printNota('get-nota-toko') } ><span className="color-birubi"><h4 className="m-0 p-0"><IoPrint /></h4>  Produksi</span></Button>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    : null
                }
                {
                    this.state.photoModalOpen ?
                        <div style={photoStyles.modalBackdrop} onClick={this.closePhotoModal}>
                            <div style={photoStyles.modalDialog} onClick={(event) => event.stopPropagation()}>
                                <button type="button" style={photoStyles.modalClose} onClick={this.closePhotoModal}>x</button>
                                <img
                                    alt="Foto transaksi"
                                    src={this.state.photoModalUrl}
                                    style={photoStyles.modalImage}
                                />
                            </div>
                        </div>
                    : null
                }
            </div>
        );
    }
}

const photoStyles = {
    thumbnailButton: {
        width: '100%',
        height: 80,
        padding: 0,
        border: '1px solid #d9e0e8',
        backgroundColor: '#f8fafc',
        overflow: 'hidden',
        cursor: 'pointer'
    },
    thumbnailImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block'
    },
    missingText: {
        display: 'none',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6c757d',
        fontSize: 11,
        textAlign: 'center',
        padding: 4
    },
    missingBox: {
        width: '100%',
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6c757d',
        fontSize: 11,
        border: '1px solid #d9e0e8',
        backgroundColor: '#f8fafc',
        textAlign: 'center',
        padding: 4
    },
    modalBackdrop: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16
    },
    modalDialog: {
        position: 'relative',
        maxWidth: '96vw',
        maxHeight: '92vh'
    },
    modalClose: {
        position: 'absolute',
        top: -12,
        right: -12,
        width: 32,
        height: 32,
        borderRadius: 16,
        border: 0,
        backgroundColor: '#ffffff',
        color: '#111827',
        fontWeight: 'bold',
        lineHeight: '32px',
        padding: 0,
        cursor: 'pointer'
    },
    modalImage: {
        maxWidth: '96vw',
        maxHeight: '92vh',
        objectFit: 'contain',
        display: 'block',
        backgroundColor: '#ffffff'
    }
}


export default CetakNota;
